import Highcharts from 'highcharts';

// Highcharts 13 defaults `palette.colorScheme` to 'light dark', so charts switch to the dark
// palette when the OS/browser is in dark mode (faded axis labels, dark label outlines, dark markers).
// The app has no dark theme — pin charts to the light palette, as they rendered in v12.
Highcharts.setOptions({
    palette: {
        colorScheme: 'light',
    },
});
